module.exports = __webpack_public_path__ + "6f724933012c860401a0ff70cd2cd8b4.mp4";